<div class="panel panel-default">
	<div class="panel-body">
		<div class="col-md-12">
			<app-grid-v2 [id]="deviceType+'-debug-records'" [columns]="gridColumns" [data]="gridData"></app-grid-v2>
		</div>
	</div>
</div>